module.exports = __webpack_public_path__ + "static/media/policiesHero.ec03f880.svg";